import en from "./en.json";
import ar from "./ar.json";
import zh from "./zh.json";
import hi from "./hi.json";
import ta from "./ta.json";
import te from "./te.json";
import tr from "./tr.json";
import th from "./th.json";
import bn from "./bn.json";
import vi from "./vi.json";
import ms from "./ms.json";
import id from "./id.json";
import ur from "./ur.json";
import tl from "./tl.json";
import pt from "./pt.json";
import es from "./es.json";

export default {
  en,
  ar,
  zh,
  hi,
  ta,
  te,
  tr,
  th,
  bn,
  vi,
  ms,
  id,
  ur,
  tl,
  pt,
  es
};
